import { Link, useNavigate, useLocation } from "react-router-dom";
import { Gem, LayoutGrid, BarChart3, User, LogOut, Crown, Coins, Shield, Swords, Egg, Sparkles } from "lucide-react";
import { useAuth } from "@/lib/auth";
import { levelFromXp } from "@/lib/rpg";
import { LOGO_MARK } from "@/lib/assets";
import { btnPrimary, btnGhost } from "@/lib/styles";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const authed = user && user !== true;

  const navItem = (to, icon, text, testid) => {
    const active = location.pathname === to;
    return (
      <Link
        to={to}
        data-testid={testid}
        className={`${btnGhost} ${active ? "text-emerald-400" : ""}`}
      >
        {icon}
        <span className="hidden md:inline">{text}</span>
      </Link>
    );
  };

  return (
    <header className="sticky top-0 z-40 border-b border-zinc-800 bg-zinc-950/90 backdrop-blur">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-16">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2 group">
          <img src={LOGO_MARK} alt="" className="w-8 h-8 select-none pointer-events-none transition-transform group-hover:scale-110" />
          <span className="font-sans font-bold text-xl tracking-tight text-zinc-100">
            Prompt<span className="text-gold">bound</span>
          </span>
        </Link>

        <nav className="flex items-center gap-1">
          {authed ? (
            <>
              {navItem("/curriculum", <LayoutGrid size={16} />, "Curriculum", "nav-curriculum")}
              {navItem("/interview", <Sparkles size={16} />, "Interview", "nav-interview")}
              {navItem("/gauntlet", <Swords size={16} />, "Gauntlet", "nav-gauntlet")}
              {navItem("/familiar", <Egg size={16} />, "Familiar", "nav-familiar")}
              {navItem("/dashboard", <BarChart3 size={16} />, "Dashboard", "nav-dashboard")}
              {user.plan !== "pro" && navItem("/pricing", <Crown size={16} />, "Go Pro", "nav-pricing")}
              {navItem("/account", <User size={16} />, "Account", "nav-account")}
              {user.is_admin && navItem("/admin", <Shield size={16} />, "Admin", "nav-admin")}
              <span className="hidden sm:inline-flex items-center gap-1 text-[11px] font-semibold text-gold border border-gold/30 bg-gold/5 px-2 py-1 rounded-md" data-testid="nav-gold" title="Gold">
                <Coins size={13} /> {user.gold ?? 0}
              </span>
              <span className="hidden sm:inline-flex items-center gap-1 text-[11px] font-semibold text-gem-light border border-gem/30 bg-gem/5 px-2 py-1 rounded-md" data-testid="nav-level" title="Level">
                Lv {levelFromXp(user.xp).level}
              </span>
              {user.plan === "pro" && (
                <span className="hidden sm:inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-wider text-yellow-400 border border-yellow-500/50 bg-yellow-950/30 px-2 py-1 ml-1 rounded-md">
                  <Crown size={12} /> Pro
                </span>
              )}
              <button data-testid="nav-logout" onClick={async () => { await logout(); navigate("/"); }} className={btnGhost}>
                <LogOut size={16} />
              </button>
            </>
          ) : (
            <>
              {navItem("/pricing", <Crown size={16} />, "Go Pro", "nav-pricing")}
              <Link to="/login" data-testid="nav-login" className={btnGhost}>Log in</Link>
              <Link to="/register" data-testid="nav-signup" className={btnPrimary}>Start free</Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
